import React from 'react';
import HomeClient from '../../components/HomeClient';

const CallCenterPage: React.FC = () => {
  return <HomeClient variant="call-center" />;
};

export default CallCenterPage;
